import React, { useState, useEffect, useContext } from 'react';

import Loader from '../Loader/Loader';
import Popup from '../Popup/Popup';
import ResultPopup from './components/ResultPopup/ResultPopup';
import AdminView from './AdminView';
import ClientView from './ClientView';
import Dropdown from '../../../../portals/AccountManagement/components/Dropdown/Dropdown';

import SurveyBuilderPageContext from '../SurveyBuilderPageContext';

import validateSurvey from './validateSurvey';

import * as mixpanel from '../../../../../mixpanel';

import amWarning from '../../../../assets/img/accountmanagement/am-warning.svg';
import publishHerdy from '../../../../assets/img/publish-herdy.svg';
import styles from './PublishSurvey.module.css';

export const stepTypes = {
  PUBLISH_SURVEY: 'PUBLISH_SURVEY',
  UNPUBLISH_SURVEY: 'UNPUBLISH_SURVEY',
  REQUEST_APPROVAL: 'REQUEST_APPROVAL',
  REQUEST_APPROVAL_CANCEL: 'REQUEST_APPROVAL_CANCEL',
  INFO: 'INFO'
};

export const moments = {
  PAST: 'PAST',
  NOW: 'NOW',
  FUTURE: 'FUTURE',
  POTENTIAL: 'POTENTIAL'
};

export const getLastEvent = arr =>
  arr
    ? [...arr]
        .sort((a, b) => new Date(a.updatedAt) - new Date(b.updatedAt))
        .pop()
    : null;

export const jumbotronLabels = {
  SCHEDULE:
    'Your schedule was successful. You can still make changes in the timeline below.',
  PUBLISH_SURVEY:
    'Your survey has been published. If you want to make any changes now, you will first have to unpublish it.',
  UNPUBLISH_SURVEY:
    'Your survey has been unpublished. You can now edit your survey',
  REQUEST_APPROVAL:
    'Your survey request is awaiting approval. You will be notified when it has been approved.'
};

export default () => {
  const [errors, setErrors] = useState(null);
  const [showResultPopup, setShowResultPopup] = useState(false);
  const { api, survey, isAdmin, surveyRefetch } = useContext(
    SurveyBuilderPageContext
  );
  const [initialSurveyLoading, setInitialSurveyLoading] = useState(true);

  const [selectedRecordToCharge, setSelectedRecordToCharge] = useState(null);
  const [listOfRecordsToCharge, setListOfRecordsToCharge] = useState(null);
  const [requestApprovalError, setRequestApprovalError] = useState(null);

  const getListOfRecordToChargeForPublish = async () =>
    api('getRecordsToCharge', {
      variables: {
        createClient: survey.client.id
      }
    });

  useEffect(() => {
    const initialSurveyRefetch = async () => {
      setInitialSurveyLoading(true);
      surveyRefetch();
      getListOfRecordToChargeForPublish();
      setTimeout(async () => {
        await surveyRefetch();

        const dataListOfRecordsToCharge = await getListOfRecordToChargeForPublish();
        if (
          dataListOfRecordsToCharge &&
          dataListOfRecordsToCharge.data &&
          dataListOfRecordsToCharge.data.getRecordsToCharge &&
          dataListOfRecordsToCharge.data.getRecordsToCharge.recordsToCharge &&
          !dataListOfRecordsToCharge.data.getRecordsToCharge.isAdmin
        ) {
          setListOfRecordsToCharge(
            dataListOfRecordsToCharge.data.getRecordsToCharge.recordsToCharge
          );
        }

        setInitialSurveyLoading(false);
      }, 900);
    };

    initialSurveyRefetch();
  }, []);

  useEffect(
    () => {
      if (survey) {
        const allErrors = validateSurvey(survey);
        const errorGroups = {};
        if (allErrors) {
          allErrors.forEach(e => {
            if (errorGroups[e.type]) {
              errorGroups[e.type].push(e.message);
            } else {
              errorGroups[e.type] = [e.message];
            }
          });
        }
        setErrors(errorGroups);
      } else setErrors([]);
    },
    [survey]
  );

  if (!survey) return null;

  if (initialSurveyLoading) {
    return <Loader />;
  }

  const RequestApprovalErrorComponent = () => (
    <div
      className="campaigns-table-publish-error-container"
      role="presentation"
      onClick={() => {
        setRequestApprovalError(false);
      }}
    >
      <div>
        <img src={amWarning} alt="Warning icon" />
      </div>
      Survey not published. Unfortunately, it appears that your license has
      expired or your account does not have enough credits to complete this
      action.
    </div>
  );

  const isRequiredToSelectRecordToCharge =
    listOfRecordsToCharge &&
    listOfRecordsToCharge.length > 1 &&
    !selectedRecordToCharge;

  return (
    <div className={styles.container}>
      {showResultPopup ? (
        <Popup
          component={
            <ResultPopup
              title="Approval has been requested"
              description="You will be notified when your request has been approved."
            />
          }
          onClose={() => setShowResultPopup(false)}
        />
      ) : null}
      <div>
        {survey.status === 'incomplete' && (
          <div>
            <div className={styles.errorTitleContainer}>
              <div className={styles.title}>Survey data check</div>
              <div className={styles.message}>Errors found</div>
            </div>
            <div className={styles.errorsContainer}>
              {errors
                ? Object.keys(errors).map((e, eIndex) => (
                    <div
                      key={`publish-survey-error-container-${eIndex.toString()}`}
                      className={styles.errorContainer}
                    >
                      <div className={styles.title}>{e}</div>
                      <div className={styles.errors}>
                        {errors[e].map((em, emIndex) => (
                          <div
                            key={`publish-survey-single-error-${emIndex.toString()}`}
                            className={styles.message}
                          >
                            <span>{em}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                : null}
            </div>
            <div className={styles.disabledPublishContainer}>
              <div className={styles.description}>
                You need to fix all the errors before you can publish your
                survey.
              </div>
              <div className={styles.buttonContainer}>
                <div className={styles.button}>Publish survey now</div>
              </div>
            </div>
          </div>
        )}

        {['testing', 'awaiting publish', 'published'].indexOf(survey.status) >
          -1 && (
          <div className={styles.campaignDataCheckContainier}>
            <div className={styles.title}>Survey data check</div>
            <div className={styles.description}>
              You have no missing data.
              <br />
              Your survey is ready to be published.
            </div>
            <img className={styles.coverImage} src={publishHerdy} alt="Herdy" />
          </div>
        )}

        {survey.status === 'testing' && !survey.approvalRequestSent && (
          <div className={styles.testingContainer}>
            <div className={styles.description}>
              You need to request approval from an admin to publish your survey.
              <br /> Once the request has been approved, your survey will
              automatically be published
            </div>
            {listOfRecordsToCharge && listOfRecordsToCharge.length > 1 ? (
              <div>
                <Dropdown
                  customPlaceholder="Charge publish from"
                  onSelectCompleted={selectedRecord =>
                    setSelectedRecordToCharge(selectedRecord)
                  }
                  fetchOptions={() =>
                    listOfRecordsToCharge
                      ? listOfRecordsToCharge.map(r => ({
                          label: r.name,
                          value: r.id
                        }))
                      : []
                  }
                  loading={false}
                  selectedValues={
                    selectedRecordToCharge ? [selectedRecordToCharge] : null
                  }
                  customContainerStyle={styles.licenceDropdownContainer}
                />
              </div>
            ) : null}
            <div className={styles.buttonContainer}>
              <div
                className={`${styles.button} ${
                  isRequiredToSelectRecordToCharge
                    ? styles.publishButtonDisabled
                    : styles.publishButton
                }`}
                role="presentation"
                onClick={async () => {
                  if (!isRequiredToSelectRecordToCharge) {
                    //   setShowSurveyPublishedPopup(true);
                    const res = await api(
                      'requestApproval',
                      {
                        variables: {
                          survey: survey.id,
                          status: true,
                          charge:
                            selectedRecordToCharge &&
                            selectedRecordToCharge.value
                              ? selectedRecordToCharge.value
                              : null
                        }
                      },
                      600,
                      true
                    );

                    if (
                      res &&
                      res.data &&
                      res.data.requestApproval &&
                      res.data.requestApproval.errors &&
                      res.data.requestApproval.errors[0] &&
                      res.data.requestApproval.errors[0].message
                    ) {
                      setRequestApprovalError(
                        res.data.requestApproval.errors[0].message
                      );
                      return;
                    }

                    setShowResultPopup(true);
                    surveyRefetch();
                    mixpanel.actions.trackEvent(
                      mixpanel.events.CLIENT_REQUEST_APPROVAL,
                      {
                        [mixpanel.eventProperties.SURVEY_ID]: survey.id
                      }
                    );
                  }
                }}
              >
                Request approval
              </div>
            </div>
          </div>
        )}

        {['testing', 'awaiting publish', 'published'].indexOf(survey.status) >
          -1 &&
        (survey.approvalRequestSent || survey.paid) &&
        isAdmin ? (
          <AdminView
            survey={survey}
            getSurvey={surveyRefetch}
            setShowResultPopup={setShowResultPopup}
            surveyRefetch={surveyRefetch}
          />
        ) : (
          <ClientView survey={survey} getSurvey={surveyRefetch} />
        )}

        {requestApprovalError && (
          <Popup
            key="error"
            component={<RequestApprovalErrorComponent />}
            onClose={() => {
              setRequestApprovalError(false);
            }}
          />
        )}
      </div>
    </div>
  );
};
